import { Typography } from '@mui/material';
import { sxDarkGreyBody } from '../../../../assets/styles/CommonSxProps';
import PageTitle from '../../../../components/Accessibility/PageTitle';
import './styles.css';

import React from "react";

const highlightPhone = (text: string) => {  
  const regex = /(\(?\d{2}\)?[\s-]?\d{4,5}-?\d{4})/g;

  const parts = text.split(regex);

  return parts.map((part, index) =>
    regex.test(part) ? (
      <span key={index} className="phone-highlight">
        {part}
      </span>
    ) : (
      part
    )
  );
};

const ConversasPersonalDisable: React.FC = () => {
  const mensagem = `Olá, o Espaço Personal encerrou as atividades em 01/04/2026.
  Solicitamos que entre em contato pelo WhatsApp (19) 99952-2208 apenas mensagem de texto.
    
  Um atendente estará disponável para esclarecer as suas dúvidas.
  Agradecemos a compreensão.`;

  return (
    <div className="chat-infos-container">
      <div className="chat-card">
        <div className="chat-card-title">
          <span>⚠️</span>
          <span>Atenção</span>
        </div>

        <div className="chat-card-text">
          {highlightPhone(mensagem)}
        </div>
      </div>
    </div>
  );
};

export default ConversasPersonalDisable;